
import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { formatMoney, formatMoneyShorten, getCurrentYear } from "../Helpers";
import { FaAndroid, FaApple, FaArrowCircleRight, FaChalkboardTeacher, FaGlobe } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople, IoMdArrowDropright } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import { MdArrowRight, MdCheck, MdLocationPin, MdSearch } from "react-icons/md";

export default function OneService({ title, icon: Icon, content, navToLink = {} }) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ ready, setReady ] = useState(false);

	async function init() {
		//run initializations here
		setReady(false);
		//..
		
		setReady(true);
	}

	useEffect(() => {
		init();
	}, [ ])

	
	return (
		<div 
			className="card"
			style={{
				height: "auto",
				cursor: "pointer",
				position: 'relative',
				overflow: "hidden",
			}}

			onClick={() => {
				//appContext.navTo(navToLink)
				appContext.navTo(navToLink)
			}}
		>
			
			<div 
				className="d-flex gap-3 align-items-center p-3"
				style={{ 
					width: "100%", 
					height: "auto", 
				}}
			>
				{Icon && <Icon size={48} className="text-secondary flex-shrink-0" />}
				<h6
					style={{
					wordBreak: "break-word",
					}}
					className="font-bold text-dim title-text"
				>
					{title}
				</h6>
			</div>

			<div 
				className="text-dim px-3"
			>
				{content}
			</div>

			<hr />

			<div className="text-end px-3 pb-3">
				<MdArrowRight size={32} />
			</div>

		</div>
	)
	

	
}
